import routeName from '../constant';

const routes = [{
    path: 'vu07',
    name: routeName.VU07,
    component: () => import('@/views/aplCatl640and631/AF/landingPage/Index.vue'),
    meta: { auth: true, metaTitle: '指定扣取每月費用之順序', leaveAlert: true, code: 'AF', unableBack: true },
}];

export default routes;
